module.exports = __webpack_public_path__ + "static/media/videoFinance.444d61be.mp4";